import { Component, OnInit } from '@angular/core';
import { ImportService } from '../../../services/import.service';
import { UserService } from '../../../services/user.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-data-pro',
  templateUrl: './data-pro.component.html',
  styleUrls: ['./data-pro.component.scss']
})
export class DataProComponent implements OnInit {

  isSuperAdmin = false;

  activeStep: number;

  //showProImport = false;

  showMapHeaders = false;

  showReadyToMap = false;

  //tracks what step we're on
  breadcrumbs = [];

  profileId = null;

  importId = null;

  get routeUrl(): string {
    var route = this.router.url;
    return route;
  }

  constructor(private importService: ImportService, public userService: UserService, private router: Router, private route: ActivatedRoute) {
  }

  ngOnInit() {

    //uncomment to test for non-superuser view
    //this.userService.currentUser.is_superuser = false;

    //used to track permissions to various views
    this.isSuperAdmin = this.userService?.currentUser?.is_superuser ?? false;

    // console.log("ProComponent init")

    
    // // this.importService.showProImport$.subscribe((x) => {
    // //   this.showProImport = x;
    // // });

    // this.importService.breadCrumbActiveStep$.subscribe((x) => {
    //   this.activeStep = x;

    //   console.log(`active step: ${this.activeStep}`)


    //   this.route.queryParams.subscribe(params => {
    //     this.profileId = params['profileId'];
    //     console.log('Profile ID:', this.profileId);

    //     // adding manual check for archive until I determine navigation to this view
    //     if (this.activeStep == null && !this.profileId && this.router.url != '/data/pro/archive') {
    //       this.routeToImportDetails();
    //     }
    //     else if (this.activeStep == this.breadcrumbs[0]?.value && this.isSuperAdmin && !this.profileId && this.router.url != '/data/pro/archive') {
    //       this.routeToImport();
    //     }
    //     // else if (this.activeStep == this.breadcrumbs[1]?.value && !this.profileId) {
    //     //   this.routeToPartnerGroupAndShowMapper();
    //     // }


    //     this.importService.importId$.subscribe((xId => {
    //       this.importId = xId;

    //       this.importService.showHeaderMapper$.subscribe((x) => {
    //         this.showMapHeaders = x;

    //         if (this.showMapHeaders && this.isSuperAdmin && !this.profileId && this.importId) {
    //           this.routeToLabelMapper(this.importId);
    //         }
    //       });
    //     }))


    //     this.importService.showReadyToMap$.subscribe((x) => {
    //       this.showReadyToMap = x;

    //       if (this.showReadyToMap && this.isSuperAdmin && !this.profileId) {
    //         this.routeToReadyToMap();
    //       }
    //     });

    //   });




    // });




    // this.breadcrumbs = this.importService.breadcrumbs;

    // //set step for breadCrumbs
    // // this.setActiveStep('import');
  }

  /**
   * Tracks what step we are on for the import process
   * Determines what components are displayed
   * @param index 
   */
  setActiveStep(title: string) {
    const breadcrumb = this.breadcrumbs.find(item => item.title.toLowerCase() === title.toLowerCase());
    if (breadcrumb) {
      this.importService.setBreadCrumbActiveStep(breadcrumb.value);
    }
  }


  routeToImportDetails() {
    this.router.navigate(['data/pro/import-details']);
  }

  routeToImport() {
    this.router.navigate(['data/pro/import']);
  }

  routeToPartnerGroupAndShowMapper() {
    this.router.navigate(['data/pro/partner-group-show-mapper'])
  }

  routeToLabelMapper(importId) {
    this.router.navigate(['data/pro/label-mapper'], {
      queryParams: { importId: importId }
    });
  }

  routeToReadyToMap() {
    this.router.navigate(['data/pro/ready-to-map']);
  }

}
